import { Storage } from '@/enums/storage.enum';
/**
 * Moduł danych systemowych
 *
 * @export
 * @class SystemModule
 */
export class SystemModule {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   * @memberof SystemModule
   */
  public namespaced: boolean = true;

  /**
   * Stan store
   *
   * @type {object}
   * @memberof SystemModule
   */
  public state: any = {
    // wersja kompilacji
    packageVersion: process.env.PACKAGE_VERSION,
    // data kompilacji
    buildDate: process.env.PACKAGE_BUILD_DATE,
    appTitle: process.env.APP_TITLE || 'Smart Club Manager',
    // wersja jezykowa
    lang: localStorage.getItem(Storage.LANG) || 'pl'
  };

  public mutations = {
    setLanguage(localState: any, lang: any) {
      localState.lang = lang;
      localStorage.setItem(Storage.LANG, lang);
    }
  };
}

export default new SystemModule();
